<template src='./TarjetasFormulario.html'>

</template>
<script>
import metodos_comunes from '../../js/metodos_comunes'
import { actualizarFormulario } from '../../apiService/request/CrudFormulario'
import { serverBus } from "../../main";
export default {
    data() {
        return {
            valor_index:'',
            bandera_ver_mas:false
        }
    },
    updated() {
    },
    computed: {
        nombreFormulariosPorTipo:function(){
            let filtro_n=Object.keys(this.formulario_por_tipo.variable)
            const self =this
            let filtro_nombre= filtro_n.filter(key=>self.formulario_por_tipo.variable[key].nombre = "Nombre")
        }
    },
    props: {
        formulario_por_tipo: {
            type: Object,
            required: true
        }
    },
    methods: {
        cambiarEstadoModal(estado){
            this.$store.dispatch('cambiarEstadoModal', estado)
        },
        cambiarIconoModal(src){
            this.$store.dispatch('cambiarIconoModal', src)
        },
        verMas:function(){
            // this.valor_index=index
            this.bandera_ver_mas=!this.bandera_ver_mas
        },
        convertirMilisegundosAFechaCompleta(fecha){
            let d = new Date(fecha);
            let semana = ["Domingo","Lunes", 'Martes', 'Miercoles', 'Jueves','Viernes', 'Sabado']
            let dia_semana= semana[d.getDay()]
            let dia= d.getDate()
            let mes = ['Ene', 'Feb', 'Mar','Abr','May','Jun','Jul','Ago', 'Sep','Oct','Nov', 'Dic']
            let nombre_mes=mes[d.getMonth()]
            let year=d.getFullYear()
            fecha= dia +' ' + nombre_mes + ' ' + 'de' + ' '+ year
            return fecha
        },
        /**Convierte en formato a.m p.m cualquier hora dada en millis
         * @param {*} hora hora en millis
         */
        convertirMilisegundosAHoraReloj(hora) { 
            let d = new Date(hora);
            let formato = 'a.m'
            let horas = d.getHours();
            let minutos = d.getMinutes();
            if(horas>=13){
                formato= 'p.m'
                horas= horas-12
            }
            if(minutos==0){
                minutos = '0'+'0' 
            }
            else if(minutos>=1 && minutos<=9 ){
                minutos = '0'+ minutos
            }
            hora  = horas + ":" + minutos + ' ' + formato
            return hora
        },
        construirVariablesActualizar:function(){
            const variablesFormulariosExistentes=this.formulario_por_tipo.variable
            const self= this
            let valorPorID
            let variablesActualizar=[]
            Object.keys(variablesFormulariosExistentes).map(function(elemento){
                valorPorID=''
                switch (variablesFormulariosExistentes[elemento].tipo){
                    case 'string': 
                        const nombreVariable= variablesFormulariosExistentes[elemento].nombre
                        valorPorID=self.$refs[nombreVariable][0].$el.value
                        break;
                    case 'fecha': 
                        valorPorID= Date.parse((self.$refs[variablesFormulariosExistentes[elemento].nombre][0].$el).getElementsByTagName('input')[0].value)+57600000
                        break;
                    case 'lista':
                        valorPorID=self.$refs[variablesFormulariosExistentes[elemento].nombre][0].$el.getElementsByTagName('input')[0].value
                        break;
                    case 'numero':
                        valorPorID=parseInt(self.$refs[variablesFormulariosExistentes[elemento].nombre][0].$el.value)
                        break;
                }
                if(variablesFormulariosExistentes[elemento].valor!=valorPorID && valorPorID!="" && valorPorID!=null){
                    variablesActualizar.push({"nombre":elemento, "valor":valorPorID, "nombre_campo": metodos_comunes.reemplazarCaracteresEspeciales(variablesFormulariosExistentes[elemento].nombre)})
                }
            })
            this.guardar(this.formulario_por_tipo.docId,variablesActualizar)   
        },
        async guardar( id_formulario, variablesActualizar){
            try {
                if(variablesActualizar.length>0){
                    const respuesta = await actualizarFormulario(id_formulario,this.$store.getters.getNombreFormulario, variablesActualizar, 'formularios', this.$store.state.provider_email)
                    serverBus.$emit("formularioActualizadoExitosamente", respuesta);
                    this.$store.dispatch('cambiarEstadoModal', true);
                    this.$store.dispatch('cambiarMensajeModal', respuesta);
                    this.cambiarIconoModal("../assets/check2.png")
                }
            }
            catch (err){
            }
        },

    },
}
</script>
<style lang="scss" src='./TarjetasFormulario.css' scoped>
</style>



// WEBPACK FOOTER //
// src/components/Formulario/TarjetasFormulario.vue